// See: https://nivo.rocks/guides/theming/
const fontFamily = "var(--font-sans)";

const SesamyNivoTheme = {
  labels: {
    text: {
      fontSize: "var(--text-base)",
      fill: "var(--foreground)",
      fontFamily,
    },
  },
  legends: {
    itemSpacing: 4,
    text: {
      fontSize: "var(--text-base)",
      fontFamily,
      fill: "var(--foreground)",
    },
  },
  tooltip: {
    fontFamily,
    fontSize: "var(--text-sm)",
    container: {
      background: "var(--card)",
      borderRadius: "var(--radius)",
      border: "1px solid var(--border)",
      boxShadow: "var(--shadow-lg)",
    },
    chip: {
      borderRadius: "100%",
      width: "8px",
      height: "8px",
    },
    tableCell: {
      color: "var(--muted-foreground)",
    },
    tableCellValue: {
      color: "var(--foreground)",
      fontWeight: 500,
    },
  },
  // Used in Line- & Bar chart
  axis: {
    ticks: {
      line: {
        stroke: "transparent",
      },
      text: {
        fill: "var(--muted-foreground)",
        fontSize: "var(--text-sm)",
      },
    },
    legend: {
      text: {
        fill: "var(--muted-foreground)",
      },
    },
  },
  grid: {
    line: {
      strokeWidth: 1,
      stroke: "var(--border)",
    },
  },
  crosshair: {
    line: {
      stroke: "var(--foreground)",
    },
  },
};

export default SesamyNivoTheme;
